import { useEffect, useState } from "react";
import { fetchMedia, useStyles } from "./Content";

const Image = ({ name, id, setExpandedImage, config }) => {
  const [image, setImage] = useState();
  const [err, setErr] = useState(false);
  const classes = useStyles({});

  useEffect(() => {
    fetchMedia(id)
      .then(data =>
        setImage(
          `${data.public_url}?auto=format&q=60&max-w=${window.innerWidth}&fit=fill`,
        ),
      )
      .catch(e => {
        console.error(e);
        setErr(true);
      });
  }, [id]);

  if (err) return <div className={classes.error}>Failed to load image</div>;

  return (
    <img
      className={classes.noteImage}
      src={image}
      alt=""
      onClick={evt =>
        void (evt.stopPropagation(),
        setExpandedImage({
          config: {
            type: "gallery",
            options: {
              title: name,
              content: [image],
            },
          },
          prev: config,
        }))
      }
    />
  );
};

export default Image;
